module.exports = __webpack_public_path__ + "img/asian-soup-1.ef0732b5.jpg";